import React, { CSSProperties } from 'react'

interface Props {
  online: boolean
  style?: CSSProperties
  floatRight?: boolean
}

const OnlineBadge: React.FC<Props> = ({ online, style, floatRight }) => (
  <>
    {online && (
      <span className={`ml-2 ${floatRight ? 'float-right' : ''}`}>
        <span className="badge badge-pill badge-warning zm-badge rounded-pill" style={style}>
          オンライン診療
        </span>
      </span>
    )}
  </>
)

export default OnlineBadge
